export const ACTIVITY_EDIT_PAGE_TEST_ID = 'activity-edit-page';
export const ACTIVITY_EDIT_AI_GENERATED_NOTICE_TEST_ID = 'activity-edit-ai-generated-notice';
export const ACTIVITY_EDIT_BACK_BUTTON_TEST_ID = 'activity-edit-back-button';
export const ACTIVITY_EDIT_SAVE_STATUS_TEST_ID = 'activity-edit-save-status';

// KT-200.5: persistent left-panel warning when the activity is in two or more projects.
export const ACTIVITY_EDIT_MULTI_PROJECT_WARNING_TEST_ID = 'activity-edit-multi-project-warning';
export const ACTIVITY_EDIT_MULTI_PROJECT_WARNING_ICON_TEST_ID = 'activity-edit-multi-project-warning-icon';

// KT-200.5: one-shot autosave awareness snackbar (wired in FE-5).
export const ACTIVITY_EDIT_MULTI_PROJECT_SNACKBAR_TEST_ID = 'activity-edit-multi-project-snackbar';
export const ACTIVITY_EDIT_COLUMN_LEFT_TEST_ID = 'activity-edit-column-left';
export const ACTIVITY_EDIT_COLUMN_MAIN_TEST_ID = 'activity-edit-column-main';
export const ACTIVITY_EDIT_NAME_FIELD_TEST_ID = 'activity-edit-name-field';
export const ACTIVITY_EDIT_NAME_INPUT_TEST_ID = 'activity-edit-name-input';
export const ACTIVITY_EDIT_DESCRIPTION_FIELD_TEST_ID = 'activity-edit-description-field';
export const ACTIVITY_EDIT_DESCRIPTION_INPUT_TEST_ID = 'activity-edit-description-input';
export const ACTIVITY_EDIT_INSTRUCTIONS_FIELD_TEST_ID = 'activity-edit-instructions-field';

// KT-611 (UI slice): hidden scaffold for Kapcsolódó Tudástár tartalom editor on the edit page.
export const ACTIVITY_EDIT_KNOWLEDGE_BASE_LINKS_TEST_ID = 'activity-edit-knowledge-base-links';
export const ACTIVITY_EDIT_KNOWLEDGE_BASE_LINKS_ADD_TEST_ID = 'activity-edit-knowledge-base-links-add';

// FE-7 (KT-200.3): rich-HTML content sections editor hosted on the edit page.
export const ACTIVITY_EDIT_SECTIONS_TEST_ID = 'activity-edit-sections';

// KT-681 / FE-6 (S14): snackbar when `PUT …/sections` rejects a foreign image source.
export const ACTIVITY_EDIT_SECTIONS_IMAGE_SOURCE_ERROR_SNACKBAR_TEST_ID =
  'activity-edit-sections-image-source-error-snackbar';

// FE-7: colored card header and the structured
// field grid (type, workform, duration, grade, subject, tools).
export const ACTIVITY_EDIT_CARD_HEADER_TEST_ID = 'activity-edit-card-header';
export const ACTIVITY_EDIT_GEAR_BUTTON_TEST_ID = 'activity-edit-gear-button';
export const ACTIVITY_EDIT_CARD_DISPLAY_MENU_TEST_ID = 'activity-edit-card-display-menu';
export const ACTIVITY_EDIT_CARD_DISPLAY_MENU_OTHER_SECTION_TEST_ID = 'activity-edit-card-display-menu-other-section';
export const ACTIVITY_EDIT_CUSTOM_FIELDS_SECTION_TEST_ID = 'activity-edit-custom-fields-section';
export const ACTIVITY_EDIT_CUSTOM_FIELD_ADD_BOTTOM_TEST_ID = 'activity-edit-custom-field-add-bottom';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_FORM_TEST_ID = 'activity-edit-custom-field-create-form';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_NAME_TEST_ID = 'activity-edit-custom-field-create-name';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_DESCRIPTION_TEST_ID = 'activity-edit-custom-field-create-description';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_TYPE_TEST_ID = 'activity-edit-custom-field-create-type';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_ENUM_OPTIONS_TEST_ID = 'activity-edit-custom-field-create-enum-options';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_ADD_TEST_ID = 'activity-edit-custom-field-create-add';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_CANCEL_TEST_ID = 'activity-edit-custom-field-create-cancel';
export const ACTIVITY_EDIT_CUSTOM_FIELD_CREATE_SAVE_TEST_ID = 'activity-edit-custom-field-create-save';

/**
 * @param fieldId - Custom pedagogical field row id.
 * @returns Test id for that custom row's delete control.
 */
export function activityEditCardDisplayMenuCustomDeleteTestId(fieldId: string): string {
  return `activity-edit-card-display-menu-custom-delete-${fieldId}`;
}

/**
 * @param fieldId - Custom pedagogical field row id.
 * @returns Test id for that custom row's edit control.
 */
export function activityEditCardDisplayMenuCustomEditTestId(fieldId: string): string {
  return `activity-edit-card-display-menu-custom-edit-${fieldId}`;
}

/**
 * @param fieldId - Custom pedagogical field the drag handle belongs to.
 * @returns Test id for that custom row's drag handle.
 */
export function activityEditCardDisplayMenuCustomHandleTestId(fieldId: string): string {
  return `activity-edit-card-display-menu-custom-handle-${fieldId}`;
}

/**
 * @param fieldId - Custom pedagogical field row id.
 * @returns Test id for that custom row.
 */
export function activityEditCardDisplayMenuCustomRowTestId(fieldId: string): string {
  return `activity-edit-card-display-menu-custom-row-${fieldId}`;
}

export const ACTIVITY_EDIT_CUSTOM_FIELD_DELETE_DIALOG_TEST_ID = 'activity-edit-custom-field-delete-dialog';
export const ACTIVITY_EDIT_CUSTOM_FIELD_DELETE_DIALOG_CANCEL_TEST_ID =
  'activity-edit-custom-field-delete-dialog-cancel';
export const ACTIVITY_EDIT_CUSTOM_FIELD_DELETE_DIALOG_CONFIRM_TEST_ID =
  'activity-edit-custom-field-delete-dialog-confirm';

/**
 * @param fieldName - Pedagogical field the drag handle belongs to.
 * @returns Test id for that extra row's drag handle.
 */
export function activityEditCardDisplayMenuPedagogicalHandleTestId(fieldName: string): string {
  return `activity-edit-card-display-menu-pedagogical-handle-${fieldName}`;
}

/**
 * @param fieldName - Pedagogical field the gear-menu row belongs to.
 * @returns Test id for that pedagogical row.
 */
export function activityEditCardDisplayMenuPedagogicalRowTestId(fieldName: string): string {
  return `activity-edit-card-display-menu-pedagogical-row-${fieldName}`;
}

export const ACTIVITY_EDIT_CARD_DISPLAY_MENU_REORDER_LIVE_TEST_ID = 'activity-edit-card-display-menu-reorder-live';

export const ACTIVITY_EDIT_PEDAGOGICAL_FIELDS_TEST_ID = 'activity-edit-pedagogical-fields';
export const ACTIVITY_EDIT_CUSTOM_PEDAGOGICAL_FIELDS_TEST_ID = 'activity-edit-custom-pedagogical-fields';

/**
 * @param rowId - dummy catalogue row id in the card display menu (design spike)
 * @returns The result of this operation.
 */
export function activityEditCardDisplayMenuRowTestId(rowId: string): string {
  return `activity-edit-card-display-menu-row-${rowId}`;
}

/**
 * @param fieldId - Custom pedagogical field row id.
 * @returns Test id for that custom editor control.
 */
export function activityEditCustomPedagogicalFieldHintTestId(fieldId: string): string {
  return `activity-edit-custom-pedagogical-field-hint-${fieldId}`;
}

/**
 * @param fieldId - Custom pedagogical field row id.
 * @returns Test id for that custom editor input control.
 */
export function activityEditCustomPedagogicalFieldInputTestId(fieldId: string): string {
  return `activity-edit-custom-pedagogical-field-${fieldId}-input`;
}

/**
 * @param fieldId - Custom pedagogical field row id.
 * @returns Test id for that custom editor field wrapper.
 */
export function activityEditCustomPedagogicalFieldTestId(fieldId: string): string {
  return `activity-edit-custom-pedagogical-field-${fieldId}`;
}

/**
 * @param fieldName - Catalogue pedagogical field name on the edit form.
 * @returns Test id for that field's input control.
 */
export function activityEditPedagogicalFieldInputTestId(fieldName: string): string {
  return `activity-edit-pedagogical-field-${fieldName}-input`;
}

/**
 * @param fieldName - Catalogue pedagogical field name on the edit form.
 * @returns Test id for that field's wrapper.
 */
export function activityEditPedagogicalFieldTestId(fieldName: string): string {
  return `activity-edit-pedagogical-field-${fieldName}`;
}

export const ACTIVITY_EDIT_EYEBROW_TEST_ID = 'activity-edit-eyebrow';

/**
 * @param activityId - loaded instance id
 * @returns print trigger test id on the edit card header
 */
export function activityEditPrintButtonTestId(activityId: string): string {
  return `activity-edit-print-button-${activityId}`;
}

/**
 * @param activityId - loaded instance id
 * @returns stable print root id for ngx-print on the edit card
 */
export function activityEditPrintSectionId(activityId: string): string {
  return `activity-edit-print-section-${activityId}`;
}
export const ACTIVITY_EDIT_FIELD_GRID_TEST_ID = 'activity-edit-field-grid';
export const ACTIVITY_EDIT_TYPE_FIELD_TEST_ID = 'activity-edit-type-field';
export const ACTIVITY_EDIT_TYPE_SELECT_TEST_ID = 'activity-edit-type-select';
export const ACTIVITY_EDIT_SUBTYPE_FIELD_TEST_ID = 'activity-edit-subtype-field';
export const ACTIVITY_EDIT_SUBTYPE_SELECT_TEST_ID = 'activity-edit-subtype-select';
export const ACTIVITY_EDIT_WORKFORM_FIELD_TEST_ID = 'activity-edit-workform-field';
export const ACTIVITY_EDIT_WORKFORM_SELECT_TEST_ID = 'activity-edit-workform-select';
export const ACTIVITY_EDIT_GRADE_FIELD_TEST_ID = 'activity-edit-grade-field';
export const ACTIVITY_EDIT_GRADE_SELECT_TEST_ID = 'activity-edit-grade-select';

/**
 * Grade option in the portaled Évfolyam list. Suffix is the grade number from `evfolyam.N`.
 *
 * @param gradeValue - Stable grade number (`1`–`12`), or the catalog id when the path has no number.
 * @returns `activity-edit-grade-option-{gradeValue}`.
 */
export function activityEditGradeOptionTestId(gradeValue: string): string {
  return `activity-edit-grade-option-${gradeValue}`;
}

export const ACTIVITY_EDIT_LOCATIONS_FIELD_TEST_ID = 'activity-edit-locations-field';
export const ACTIVITY_EDIT_LOCATIONS_SELECT_TEST_ID = 'activity-edit-locations-select';
export const ACTIVITY_EDIT_SUBJECT_FIELD_TEST_ID = 'activity-edit-subject-field';
export const ACTIVITY_EDIT_SUBJECT_SELECT_TEST_ID = 'activity-edit-subject-select';
export const ACTIVITY_EDIT_VISIBILITY_FIELD_TEST_ID = 'activity-edit-visibility-field';
export const ACTIVITY_EDIT_VISIBILITY_SELECT_TEST_ID = 'activity-edit-visibility-select';
export const ACTIVITY_EDIT_DURATION_FIELD_TEST_ID = 'activity-edit-duration-field';
export const ACTIVITY_EDIT_DURATION_VALUE_INPUT_TEST_ID = 'activity-edit-duration-value-input';
export const ACTIVITY_EDIT_DURATION_UNIT_SELECT_TEST_ID = 'activity-edit-duration-unit-select';
export const ACTIVITY_EDIT_TOOLS_TEST_ID = 'activity-edit-tools';

// FE-6 (KT-200.4): Kontextus (context documents) read/remove list under the editor sections
// (`app-activity-context-section`). The add trigger next to it (`app-document-attach-trigger`)
// carries its own variant-based test id.
export const ACTIVITY_EDIT_CONTEXT_SECTION_TEST_ID = 'activity-edit-context-section';

// FE-6 (KT-200.4, scenario S1): reason shown next to the disabled add trigger once the 20-document
// Kontextus ceiling is reached — the "inaktív, indokkal" half of S1.
export const ACTIVITY_EDIT_CONTEXT_ADD_DISABLED_REASON_TEST_ID = 'activity-edit-context-add-disabled-reason';

// FE-10: snackbar shown when a deep-linked `activity/:id/edit` id cannot be resolved
// (deleted / never-existed / another teacher's private instance — S25).
export const ACTIVITY_EDIT_DEEP_LINK_ERROR_TEST_ID = 'activity-edit-deep-link-error';

// FE-10 review fix: main-column states other than the loaded editor card. Without these the
// `error` outcome rendered nothing (blank page); the loading and load-error surfaces make the
// resolution's transient / failed states visible (the header back-arrow stays available so the
// teacher can leave).
export const ACTIVITY_EDIT_LOADING_TEST_ID = 'activity-edit-loading';
export const ACTIVITY_EDIT_LOAD_ERROR_TEST_ID = 'activity-edit-load-error';

export const ACTIVITY_EDIT_STICKER_CARD_TEST_ID = 'activity-edit-sticker-card';
export const ACTIVITY_EDIT_STICKER_EMPTY_STATE_TEST_ID = 'activity-edit-sticker-empty-state';
export const ACTIVITY_EDIT_STICKER_GENERATE_BUTTON_TEST_ID = 'activity-edit-sticker-generate-button';
export const ACTIVITY_EDIT_STICKER_SPINNER_TEST_ID = 'activity-edit-sticker-spinner';
export const ACTIVITY_EDIT_STICKER_IMAGE_TEST_ID = 'activity-edit-sticker-image';
export const ACTIVITY_EDIT_STICKER_DOWNLOAD_BUTTON_TEST_ID = 'activity-edit-sticker-download-button';
export const ACTIVITY_EDIT_STICKER_REGENERATE_BUTTON_TEST_ID = 'activity-edit-sticker-regenerate-button';
export const ACTIVITY_EDIT_STICKER_REGENERATE_POPOVER_TEST_ID = 'activity-edit-sticker-regenerate-popover';
export const ACTIVITY_EDIT_STICKER_REGENERATE_REQUEST_INPUT_TEST_ID = 'activity-edit-sticker-regenerate-request-input';
export const ACTIVITY_EDIT_STICKER_REGENERATE_SUBMIT_BUTTON_TEST_ID = 'activity-edit-sticker-regenerate-submit-button';
export const ACTIVITY_EDIT_STICKER_ERROR_SNACKBAR_TEST_ID = 'activity-edit-sticker-error-snackbar';
export const ACTIVITY_EDIT_STICKER_LEAVE_DIALOG_TEST_ID = 'activity-edit-sticker-leave-dialog';
export const ACTIVITY_EDIT_STICKER_LEAVE_DIALOG_CONFIRM_TEST_ID = 'activity-edit-sticker-leave-dialog-confirm';
export const ACTIVITY_EDIT_STICKER_LEAVE_DIALOG_CANCEL_TEST_ID = 'activity-edit-sticker-leave-dialog-cancel';

export const ACTIVITY_EDIT_COVER_ACTION_TEST_ID = 'activity-edit-cover-action';
export const ACTIVITY_EDIT_COVER_GENERATE_BUTTON_TEST_ID = 'activity-edit-cover-generate-button';
export const ACTIVITY_EDIT_COVER_RETRY_BUTTON_TEST_ID = 'activity-edit-cover-retry-button';
export const ACTIVITY_EDIT_COVER_SPINNER_TEST_ID = 'activity-edit-cover-spinner';
export const ACTIVITY_EDIT_COVER_ERROR_ICON_TEST_ID = 'activity-edit-cover-error-icon';
export const ACTIVITY_EDIT_COVER_ERROR_GLYPH_TEST_ID = 'activity-edit-cover-error-glyph';
export const ACTIVITY_EDIT_COVER_ERROR_TEXT_TEST_ID = 'activity-edit-cover-error-text';
export const ACTIVITY_EDIT_COVER_HEADER_IMAGE_TEST_ID = 'activity-edit-cover-header-image';
export const ACTIVITY_EDIT_COVER_MENU_TEST_ID = 'activity-edit-cover-menu';
export const ACTIVITY_EDIT_COVER_MENU_SHOW_IMAGE_TEST_ID = 'activity-edit-cover-menu-show-image';
export const ACTIVITY_EDIT_COVER_MENU_DOWNLOAD_TEST_ID = 'activity-edit-cover-menu-download';
export const ACTIVITY_EDIT_COVER_MENU_REGENERATE_TEST_ID = 'activity-edit-cover-menu-regenerate';
export const ACTIVITY_EDIT_COVER_LARGE_VIEW_TEST_ID = 'activity-edit-cover-large-view';
export const ACTIVITY_EDIT_COVER_LARGE_VIEW_IMAGE_TEST_ID = 'activity-edit-cover-large-view-image';
export const ACTIVITY_EDIT_COVER_LARGE_VIEW_ERROR_TEST_ID = 'activity-edit-cover-large-view-error';
export const ACTIVITY_EDIT_COVER_DOWNLOAD_BUTTON_TEST_ID = 'activity-edit-cover-download-button';
export const ACTIVITY_EDIT_COVER_REGENERATE_BUTTON_TEST_ID = 'activity-edit-cover-regenerate-button';
export const ACTIVITY_EDIT_COVER_CONFIRM_DIALOG_TEST_ID = 'activity-edit-cover-confirm-dialog';
export const ACTIVITY_EDIT_COVER_CONFIRM_DIALOG_CONFIRM_TEST_ID = 'activity-edit-cover-confirm-dialog-confirm';
export const ACTIVITY_EDIT_COVER_CONFIRM_DIALOG_CANCEL_TEST_ID = 'activity-edit-cover-confirm-dialog-cancel';
export const ACTIVITY_EDIT_COVER_LEAVE_DIALOG_TEST_ID = 'activity-edit-cover-leave-dialog';
export const ACTIVITY_EDIT_COVER_LEAVE_DIALOG_CONFIRM_TEST_ID = 'activity-edit-cover-leave-dialog-confirm';
export const ACTIVITY_EDIT_COVER_LEAVE_DIALOG_CANCEL_TEST_ID = 'activity-edit-cover-leave-dialog-cancel';
export const ACTIVITY_EDIT_COVER_ERROR_SNACKBAR_TEST_ID = 'activity-edit-cover-error-snackbar';

export const ACTIVITY_PROJECT_PANEL_TEST_ID = 'activity-project-panel';
export const ACTIVITY_PROJECT_PANEL_LOADING_TEST_ID = 'activity-project-panel-loading';
export const ACTIVITY_PROJECT_PANEL_ERROR_TEST_ID = 'activity-project-panel-error';
export const ACTIVITY_PROJECT_PANEL_ERROR_RETRY_TEST_ID = 'activity-project-panel-error-retry';
export const ACTIVITY_PROJECT_PANEL_RENAME_ERROR_SNACKBAR_TEST_ID = 'activity-project-panel-rename-error-snackbar';
export const ACTIVITY_PROJECT_PANEL_RENAME_CONFLICT_SNACKBAR_TEST_ID =
  'activity-project-panel-rename-conflict-snackbar';
export const ACTIVITY_PROJECT_PANEL_REMOVE_ERROR_SNACKBAR_TEST_ID = 'activity-project-panel-remove-error-snackbar';
export const ACTIVITY_PROJECT_PANEL_TEMPLATE_SWAP_ERROR_SNACKBAR_TEST_ID =
  'activity-project-panel-template-swap-error-snackbar';
export const ACTIVITY_PROJECT_PANEL_ASSIGN_CARD_TEST_ID = 'activity-project-panel-assign-card';
export const ACTIVITY_PROJECT_PANEL_ASSIGN_BUTTON_TEST_ID = 'activity-project-panel-assign-button';
export const ACTIVITY_PROJECT_PANEL_ASSIGN_ICON_TEST_ID = 'activity-project-panel-assign-icon';
export const ACTIVITY_PROJECT_PANEL_MEMBERSHIP_LIST_TEST_ID = 'activity-project-panel-membership-list';
export const ACTIVITY_PROJECT_PANEL_TOC_TEST_ID = 'activity-project-panel-toc';
export const ACTIVITY_PROJECT_PANEL_TOC_NAME_TEST_ID = 'activity-project-panel-toc-name';
export const ACTIVITY_PROJECT_PANEL_TOC_NAME_INPUT_TEST_ID = 'activity-project-panel-toc-name-input';

/**
 * @param projectId - the membership row's project id
 * @returns the test id of that project's link row in the membership list
 */
export function activityProjectPanelMembershipItemTestId(projectId: string): string {
  return `activity-project-panel-membership-item-${projectId}`;
}

/**
 * @param projectActivityId - the occurrence id inside the project (not the activity id — the same
 * activity can appear twice)
 * @returns the test id of that occurrence's row in the project table of contents
 */
export function activityProjectPanelTocItemTestId(projectActivityId: string): string {
  return `activity-project-panel-toc-item-${projectActivityId}`;
}

/**
 * @param projectActivityId - the occurrence id inside the project
 * @returns the test id of that row's "remove from project" action
 */
export function activityProjectPanelTocRemoveTestId(projectActivityId: string): string {
  return `activity-project-panel-toc-remove-${projectActivityId}`;
}
